import { PropsWithChildren } from "react";
import cx from "classnames";
import style from "./circleGrid.module.css";

interface CircleGridProps extends PropsWithChildren {
  className?: string;
}

const CircleGrid: React.FC<CircleGridProps> = ({ children, className }) => {
  return (
    <div className={style.galleryContainer}>
      <div className={cx(style.gallery, className)}>{children}</div>
    </div>
  );
};

export default CircleGrid;
